import moment from 'moment/moment'

import { DataType } from '../types/DataType'
import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { Deposit } from './Deposit'
import { Payment } from './Payment'
import { FKType } from './SQLBuilder'

type BalanceConstructorArgs = ConstructorArgs<() => Balance>

export class Balance extends BaseRecord {
    readonly recordType = 'balance'

    amount: number | undefined
    type: string | undefined
    lastModifiedDate: moment.Moment | undefined
    cancelledDate: moment.Moment | undefined
    eventDate: moment.Moment | undefined
    typeString: string | undefined

    constructor(data?: Partial<BalanceConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.amount = this.propertyFromCurrencyArg(data.amount)
        this.type = data.type ?? undefined
        this.eventDate = this.propertyFromTimestampArg(data.event_date)
        this.lastModifiedDate = this.propertyFromTimestampArg(data.last_modified_date)
        this.cancelledDate = this.propertyFromTimestampArg(data.cancelled_date)
        this.typeString = data.type_string ?? undefined
    }

    clone(overrides?: Partial<BalanceConstructorArgs>): Balance {
        return new Balance({ ...this.serializeForClone(), ...overrides })
    }

    get date(): moment.Moment | undefined {
        return this.createdDate
    }

    deserialize(data: any) {
        super.deserialize(data)
        if (data.payment) this.payment = BaseRecord.fromSerializer(data.payment, Payment)
        if (data.deposit) this.deposit = BaseRecord.fromSerializer(data.deposit, Deposit)
        if (data.lastModifiedDate) this.lastModifiedDate = moment(data.lastModifiedDate)
        if (data.cancelledDate) this.cancelledDate = moment(data.cancelledDate)
        if (data.eventDate) this.eventDate = moment(data.eventDate)
    }

    static fk: FKType = {
        payments: ['payment'],
        deposits: ['deposit'],
    }

    static dataType(): DataType {
        return 'balances'
    }

    get payment(): Payment | undefined {
        return this.getForeignRecord('payment', Payment)
    }
    set payment(payment: Payment | undefined) {
        this.setForeignRecord('payment', payment)
    }
    get deposit(): Deposit | undefined {
        return this.getForeignRecord('deposit', Deposit)
    }
    set deposit(deposit: Deposit | undefined) {
        this.setForeignRecord('deposit', deposit)
    }
}
